import React from "react";

const TRUSTPILOT_REVIEWS_URL =
  "https://www.trustpilot.com/review/lettingengine.com";

interface GoogleReviewsEmbedProps {
  variant?: "light" | "dark";
}

const GoogleReviewsEmbed: React.FC<GoogleReviewsEmbedProps> = ({
  variant = "light",
}) => {
  const isDark = variant === "dark";

  return (
    <section
      className={`py-24 px-[5%] ${
        isDark ? "bg-[#1a1a1a] text-white" : "bg-bg-porcelain text-text-obsidian"
      }`}
    >
      <div className="max-w-[900px] mx-auto text-center">
        <span
          className={`font-manrope text-xs uppercase tracking-widest block mb-3 ${
            isDark ? "text-brand-yellow" : "text-text-slate"
          }`}
        >
          Trusted by landlords &amp; tenants
        </span>
        <h2
          className={`page-section-heading mb-6 ${
            isDark ? "text-white" : "text-text-obsidian"
          }`}
        >
          See our Trustpilot reviews
        </h2>
        <p
          className={`font-manrope text-base leading-relaxed max-w-xl mx-auto mb-8 ${
            isDark ? "text-white/80" : "text-text-slate"
          }`}
        >
          Read what clients say about Letting Engine on Trustpilot. We welcome
          feedback and are committed to transparent, professional service.
        </p>
        <a
          href={TRUSTPILOT_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block font-teko text-xl uppercase tracking-wider px-8 py-3 bg-brand-yellow text-text-obsidian transform skew-x-[var(--skew)] transition-all duration-300 hover:bg-yellow-400"
          aria-label="See our Trustpilot reviews"
        >
          <span className="block transform skew-x-[10deg]">
            See our Trustpilot reviews
          </span>
        </a>
      </div>
    </section>
  );
};

export default GoogleReviewsEmbed;
